import { inject, Injectable, signal } from '@angular/core';
import { ROUTE_PATH } from '@data-terminal/shared-models/navigation';
import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { Router } from '@angular/router';
import { SESSION_STORAGE } from '@data-terminal/data-access/injection-tokens';

const SESSION_STORAGE_DEVICE_ID_KEY = 'onlinePressDeviceId';

@Injectable({
    providedIn: 'root',
})
export class OnlinePressNavigationService {
    readonly #router = inject(Router);
    readonly #sessionService = inject(CCAuthService);
    readonly #sessionStorage = inject(SESSION_STORAGE);

    readonly #deviceId = signal<string | undefined>(undefined);

    public set deviceId(deviceId: string | undefined) {
        this.#deviceId.set(deviceId);

        if (deviceId) {
            this.#sessionStorage.setItem(SESSION_STORAGE_DEVICE_ID_KEY, deviceId);
        }
    }

    public get deviceId(): string | undefined {
        return this.#deviceId() || this.#sessionStorage.getItem(SESSION_STORAGE_DEVICE_ID_KEY) || undefined;
    }

    public redirectToOnlinePressDevice(): void {
        const orgId = this.#sessionService.getCurrentMembership()?.organizationId;

        if (orgId && this.deviceId) {
            void this.#router.navigateByUrl(
                `/${encodeURIComponent(orgId)}/${ROUTE_PATH.onlinePress}/${encodeURIComponent(this.deviceId)}/${ROUTE_PATH.operations}`
            );
        } else {
            void this.#router.navigateByUrl(ROUTE_PATH.error);
        }
    }
}
